/*       */

export const spaceBetweenPages = 30;
export const pageSeparatorExtraWidth = 20;
export const fontFamily = 'arial';
export const fontColor = (color) => { return color || 'black'; };
